import React from 'react';
import Header from '../components/Header/Header';
import Hero from '../components/Hero/Hero';
import CategoryIcons from '../components/Categories/CategoryIcons';
import ProductSection from '../components/Products/ProductSection';
import HighlightImage from '../components/HighlightImage/HighlightImage';
import HighlightImageTwo from '../components/HighlightImageTwo/HighlightImageTwo';
import HighlightsSection from '../components/Products/HighlightsSection';
import CategoryGrid from '../components/Categories/CategoryGrid';
import Reviews from '../components/Reviews/Reviews';
import Footer from '../components/Footer/Footer';
import FloatingButtons from '../components/FloatingButtons/FloatingButtons';
import { newArrivals, featuredCollection, specialOne } from '../data/products';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <CategoryIcons />
      <ProductSection title="New Arrivals" products={newArrivals} sectionId="new-arrivals" />
      <HighlightImage />
      <ProductSection title="Featured collection" products={featuredCollection} sectionId="featured" />
      <CategoryGrid />
      <HighlightImageTwo />
      <ProductSection title="Special One" products={specialOne} sectionId="special-one" />
      <HighlightsSection />
      <Reviews />
      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default Home;

